import {
    HomeOutlined, SettingOutlined, FileTextOutlined, DollarOutlined, TeamOutlined
} from '@ant-design/icons';

import dayjs from 'dayjs';

let pBaseUrl = window.location.protocol + "//" + window.location.host;
// let serverIP = "pd.xidigo.com";
let serverIP = window.location.host.split(':')[0];
if (process.env.NODE_ENV === 'development') {
    serverIP = "101.91.148.162"
    // serverIP = "192.168.10.2"
    // serverIP = "127.0.0.1"
}
let serverPORT = "8117";
export default {
    title: '账务管理系统',
    version: "1.0.12",
    /**
     * @description api请求基础路径
     */
    baseUrl: {
        dev: 'http://' + serverIP + ':' + serverPORT + '/api/v1/',
        pro: 'http://' + serverIP + ':' + serverPORT + '/api/v1/',
    },
    templateUrl: {
        dev: 'http://' + serverIP + ':' + serverPORT + '/',
        pro: 'http://' + serverIP + ':' + serverPORT + '/',
    },
    /**
     * @description 默认表格显示的记录条数
     */
    // baseImageUrl: {
    //     dev: 'http://' + serverIP + ':' + serverPORT + '/file/',
    //     pro: 'http://' + serverIP + ':' + serverPORT + '/file/',
    // },
    baseFileUrl: {
        dev: 'http://' + serverIP + ':' + serverPORT + '/file/',
        pro: 'http://' + serverIP + ':' + serverPORT + '/file/',
    },
    baseMediaUrl: {
        dev: 'http://' + serverIP + ':' + serverPORT + '/api/vi/media/',
        pro: 'http://' + serverIP + ':' + serverPORT + '/api/vi/media/',
    },
    websocketUri: {
        dev: serverIP + ':' + serverPORT,
        pro: window.location.host,
    },
    websocketPath: {
        dev: '',
        pro: '',
    },
    menus: [
        { name: "首页", key: "/sys/home", icon: <HomeOutlined /> },
        { name: "ISP业务", key: "/sys/isp", icon: <FileTextOutlined /> },
        { name: "代理业务", key: "/sys/agency", icon: <FileTextOutlined /> },
        { name: "账务信息", key: "/sys/accounting", icon: <DollarOutlined /> },
        { name: "客户信息", key: "/sys/customer", icon: <TeamOutlined /> },
        { name: "设置", key: "/sys/setting", icon: <SettingOutlined /> },
    ],
    defaultTheme: {
        rowLightColor: "rgb(238, 238, 238)",
        rowDarkColor: "rgb(223, 225, 234)",
        rowHighDarkColor: "rgb(171, 174, 191)",
        editBackColor: "rgb(208, 210, 222)", //"#D0D2DE"
    },
    pagination: (total, page, pageSize, onPageChange) => {
        return {
            // style: { display: total > pageSize ? "flex" : "none", margin: 10 },
            style: { display: "flex", margin: 10 },
            // pageSizeOptions: ["100", "200", "500", "1000", "2000"],
            total: total,
            pageSize: pageSize,
            current: page,
            showTotal: (total, range) => `显示第${range[0]}到第${range[1]}条记录，总共${total}条记录`,
            onChange: onPageChange,
            onShowSizeChange: onPageChange,
        }
    },
    /**
     * 版本比较
     * 版本格式示例：1.1.0
     * @param {*} v1 要求版本
     * @param {*} v2 当前版本
     * @returns
     */
    versionCompare: function (v1, v2) {
        //去掉收尾空格
        v1 = v1.replace(/(^\s+)|(\s+$)/gi, "");
        v2 = v2.replace(/(^\s+)|(\s+$)/gi, "");
        //空检查
        if (!v1 || !v2) {
            return;
        }
        //截取v1,v2中的版本数字
        v1 = /\d(\.|\d)*\d/gi.exec(v1)[0];
        v2 = /\d(\.|\d)*\d/gi.exec(v2)[0];
        //版本比较，我们分为三个数组然后比较
        let arr1 = v1.split('.');
        arr1 = arr1.map(function (item) {
            // console.log(parseInt(item));
            return parseInt(item);
        });
        let arr2 = v2.split('.');
        arr2 = arr2.map(function (item) {
            // console.log(parseInt(item));
            return parseInt(item);
        });
        if (arr1[0] > arr2[0]) {
            return true;
        } else if (arr1[0] === arr2[0]) {
            if (arr1[1] > arr2[1]) {
                return true;
            } else if (arr1[1] === arr2[1]) {
                if (arr1[2] > arr2[2]) {
                    return true;
                } else if (arr1[2] === arr2[2]) {
                    return false;
                }
            }
        }
        return false;
    },
    fallback: "data:image/png;base64,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",
    getFileFormat: (format) => {
        let type = 'OTHER';
        if (["mp3", "wav"].includes(format)) {
            type = "AUDIO";
        } else if (["mp4", "ogg", "webm"].includes(format)) {
            type = "VIDEO";
        } else if (["jpg", "jpeg", "png"].includes(format)) {
            type = "PICTURE";
        } else if (["txt"].includes(format)) {
            type = "DOCUMENT";
        } else if (["ppt", "pptx"].includes(format)) {
            type = "PPT";
        } else if (["xls", "xlsx"].includes(format)) {
            type = "XLS";
        } else if (["doc", "docx"].includes(format)) {
            type = "DOC";
        } else if (["pdf"].includes(format)) {
            type = "PDF";
        } else if (["zip", "rar"].includes(format)) {
            type = "ZIP";
        } else if (["usdz"].includes(format)) {
            type = "AR";
        }
        return type;
    },
    dateFormat: "YYYY年MM月DD日",
    dateFullFormat: "YYYY年MM月DD日 HH:mm:ss",
    dateShortFormat: "YYYY-MM-DD",
    dateShortFullFormat: "YYYY-MM-DD HH:mm:ss",
    getDateFormat: function (date, formatStr) {
        formatStr = formatStr || "YYYY.MM.DD HH:mm:ss";
        if (date) {
            // return moment(new Date(date)).format(formatStr)
            return dayjs(new Date(date)).format(formatStr)
        }
        return date;
    },
    StatusColor: [
        "#F00", "#F2C443", "#228B22", "#354F9E", "#999",
    ],
    StatusOpacityColor: [
        "rgba(233, 51, 35, .2)",
        "rgba(235, 198, 92, .2)",
        "rgba(69, 137, 51, .2)",
        "rgba(59, 77, 153, .2)",
    ],
    borderStyle: "0.5px solid #333",
    ModalFullStyle: {
        width: "100vw", maxWidth: "100vw",
        height: "100vh", maxHeight: "100vh",
        top: 0, padding: 0,
    },
    ModalFullBodyStyle: {
        padding: 0, position: "absolute", left: 0, width: "100vw",
    },
    ModalMainStyle: {
        width: "100%", height: "calc(100vh - 55px)",
        backgroundColor: "#FFF",
        // backgroundColor: "#F4F6F9",
        display: "flex", flexDirection: "column",
        justifyContent: "center", alignItems: "center",
    },
    ModalFormStyle: {
        backgroundColor: "#FFF", height: "calc(100vh - 105px)", padding: 10,
    },
    ModalContainer: {
        border: "1px solid #333", backgroundColor: '#EEE', width: '100%'
    },
    ModalPageTitleStyle: {
        textAlign: "center", color: "#FFF", backgroundColor: "#4273A9",
        fontSize: 20, fontWeight: "bold", lineHeight: "45px",
        borderBottom: "0.5px solid #333",
    },
    ModalFooterStyle: {
        width: "100%", height: 50, bottom: 0, left: 0,
        borderTop: "1px solid #AAA", backgroundColor: "#FFF",
        display: "flex", alignItems: "center", justifyContent: "center",
    },
    S_DISCARD: 99, //已作废
    typeList: [ // 显示 IP地址、安装地址 不在数组中的显示 安装地址A、安装地址B
        "商务宽带", "精品专线", "IPMAN",
        "沃银牌", "沃动车", "沃快车",
    ],
    UserRoleList: [1, 2],
    UserRoleLabel: ["系统管理员", "普通用户"],
    BusinessStatusList: [1, 2, 3], // 已作废 99
    BusinessStatusLabel: ["受理中", "报完工", "已中止"], // 已作废
    OperateStatusList: [1, 2, 3],
    OperateStatusLabel: ["正常", "变更", "拆除"],
    OperatorList: [1, 2, 3],
    OperatorLabel: ["中国电信", "中国联通", "中国移动"],
    BusinessTypeList: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    BusinessTypeLabel: [
        "商务宽带", "精品专线", "IPMAN", "MSTP（本地）", "MSTP（长途）", "VPN（本地）", "VPN（长途）", "专项项目", "其他",
    ],
    AgencyBusinessTypeLabel: [
        // 电信业务类型：
        ["IDC", "定制云", "天翼云", "商务宽带", "精品专线", "IPMAN", "MSTP（本地）", "MSTP（长途）", "VPN（本地）", "VPN（长途）", "IPRAN", "OTN", "SDWAN", "专项项目（可以自行输入）", "其他（可以自行输入）"]
    ],
    PayTypeList: [1, 2, 3, 4],
    PayTypeLabel: ["年付", "季付", "月付", "两年付"],
    AcceptTypeList: [1, 2, 3, 4, 5],
    AcceptTypeLabel: ["新装", "变更", "拆机"],
    AcceptTypeLabel2: ["新装", "变更", "拆除", "查询", "其他"],
    ChangeTypeList: [1, 2, 3, 4, 5, 6, 7],
    ChangeTypeLabel: ["升速", "降速", "增加IP", "增加资源", "移机", "变更户名", "其他"],
    AccountingList: [1, 2, 3],
    AccountingLabel: ["待付款", "已付款", "已销账"],
    AccountingLabel2: ["待收款", "已收款", "已销账"],
    AccountingStatusList: [1, 2, 3, 4], // 已作废 99
    AccountingStatusLabel: ["待结账", "即将逾期", "已逾期", "已结账",], // 已作废
    AccountingStatusOptions: ["待结账", "已结账"],
    TypeList: [1, 2],
    TypeLabel: ["ISP业务", "代理业务"],
    ISPTypeList: [1, 2],
    ISPTypeLabel: ["买进", "卖出"],
    BillTypeList: [1, 2, 3],
    BillTypeLabel: ["出账", "入账", "销账"],
    TaxTypeList: [1, 2],
    TaxTypeLabel: ["税前", "税后"],
    SaleCheckList: [1, 2, 3],
    SaleCheckLabel: ["已开票，已收款", "已开票，款未到", "未开票，未收款"],
    BillingMethodList: ["限速", "100%峰值", "95%峰值", "均值计费"], // 计费方式
    EngineeringChargingMethodLabel: ["信网部收取", "施工方收取"],
    EngineeringChargingMethodList: [1, 2],
    PortTypeLabel: ["共享100M", "独享100M", "独享1000M", "独享10000M", "10000M以上独享"],
    IPAddressTypeLabel: ["免费IP地址", "收费IP地址", "用户自带IP地址广播", "免费LINK地址", "收费LINK地址"],
    IPAddressInfoList: [
        { label: "免费IP地址", key: "free" },
        { label: "收费IP地址", key: "charge" },
        { label: "用户自带IP地址广播", key: "userOwned" },
        { label: "免费LINK地址", key: "free" },
        { label: "收费LINK地址", key: "charge" },
    ],
    IDCHostingMethodLabel: ["机位规格(U)", "机架规格", "包房面积(M²)"],
    IDCHostingMethodList: [
        { label: "机位规格(U)", key: "MachinePosition", },
        { label: "机架规格", key: "Rack", },
        { label: "包房面积(M²)", key: "RoomArea", },
    ],
    CustomCloudHostingMethodLabel: ["云空间规格(共享)", "云空间规格(独占)", "VIP云空间面积(M²)"],
    CustomCloudHostingMethodList: [
        { label: "云空间规格(共享)", key: "CloudSpaceShared", },
        { label: "云空间规格(独占)", key: "CloudSpaceExclusive", },
        { label: "VIP云空间面积(M²)", key: "VIPCloudSpaceArea", },
    ],
    CloudChannelTypeLabel: ["共享100M", "独享100M", "独享1000M", "独享10000M", "10000M以上独享", "内网端口",],
}
